import { styled } from 'stitches.config'

export const BenefitsRoot = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  color: '$accent-white',
  background: '$primary-700',
})

export const BenefitsContainer = styled('div', {
  position: 'relative',
  width: '100%',
  maxWidth: '500px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '@bp2': {
    maxWidth: '1440px',
    flexDirection: 'row',
  },
})

export const Title = styled('h2', {
  fontSize: '$h3',
  width: '100%',
  textAlign: 'center',
  maxWidth: '300px',
  margin: 'auto',
  marginBottom: '$2',

  '@bp2': {
    fontSize: '$h2',
    lineHeight: '$h1',
    maxWidth: '480px',
    textAlign: 'left',
    margin: '0 0 $2',
  },
  '@bp3': {
    fontSize: '$h1',
  },
})

export const Subtitle = styled('h3', {
  '@bp2': {
    fontSize: '$h5',
    lineHeight: '$h5',
    maxWidth: '480px',
    textAlign: 'left',
    margin: '0 0 $2',
  },
})

export const Description = styled('ul', {
  paddingLeft: '1.5rem',

  '& li': {
    fontSize: '$body',
    listStyle: 'disc',
    marginBottom: '0.5rem',
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  lineHeight: 0,
  '@bp2': { width: '50.1%' },
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  width: '100%',
  aspectRatio: '1.49/1',

  '@bp2': {
    height: '458px',
    aspectRatio: 'unset',
  },
})

export const CopyColumn = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  '@bp2': {
    width: '49.9%',
    justifyContent: 'flex-end',
  },
})

export const CopyContainer = styled('div', {
  width: '100%',
  maxWidth: '550px',
  margin: '$5 $2',

  '@bp2': {
    margin: '$3 $9 $3 $3',
  },

  '@bp3': {
    margin: '$6 $9 $6 $6',
    maxWidth: '600px',
  },
})
